import { Component, Input, OnInit } from '@angular/core';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';

@Component({
    selector: 'app-total-learning-time',
    templateUrl: './total-learning-time.component.html',
    styleUrls: ['./total-learning-time.component.scss'],
})
export class TotalLearningTimeComponent extends UnsubscribeOnDestroy implements OnInit {
    @Input()
    totalLearningTime: string;

    @Input()
    horizontalView: boolean;

    constructor() {
        super();
    }

    async ngOnInit(): Promise<void> {}
}
